import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import Icon from '../AppIcon';

const Breadcrumb = ({ customItems = null }) => {
  const location = useLocation();
  
  const getDefaultBreadcrumbs = () => {
    const pathSegments = location.pathname.split('/').filter(Boolean);
    const breadcrumbs = [{ label: 'Home', path: '/homepage-dashboard' }];
    
    const routeMap = {
      'product-catalog-category-browse': 'Products',
      'product-detail-page': 'Product Details',
      'shopping-cart': 'Shopping Cart',
      'checkout-process': 'Checkout',
      'user-authentication-login-register': 'Account'
    };
    
    pathSegments.forEach((segment, index) => {
      const path = '/' + pathSegments.slice(0, index + 1).join('/');
      const label = routeMap[segment] || segment.replace(/-/g, ' ').replace(/\b\w/g, l => l.toUpperCase());
      breadcrumbs.push({ label, path });
    });
    
    return breadcrumbs;
  };

  const breadcrumbs = customItems || getDefaultBreadcrumbs();
  
  if (breadcrumbs.length <= 1) return null;

  return (
    <nav className="flex items-center space-x-2 text-sm text-text-secondary mb-6" aria-label="Breadcrumb">
      {breadcrumbs.map((item, index) => (
        <React.Fragment key={item.path}>
          {index > 0 && (
            <Icon name="ChevronRight" size={16} className="text-border" />
          )}
          {index === breadcrumbs.length - 1 ? (
            <span className="text-text-primary font-body-semibold" aria-current="page">
              {item.label}
            </span>
          ) : (
            <Link
              to={item.path}
              className="hover:text-primary transition-smooth"
            >
              {item.label}
            </Link>
          )}
        </React.Fragment>
      ))}
    </nav>
  );
};

export default Breadcrumb;